import { Control } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from '../../../../ui/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../ui/components/ui/select';
import { formatDate } from '../../lib/format';
import { OfferCheckoutFormValues } from '../offer-checkout-form/offer-checkout-form.schema';

export interface StartDateSelectProps {
  control: Control<OfferCheckoutFormValues>;
  /** 1st/15th of the next months, from the backend. */
  options: string[];
}

const StartDateSelect = ({ control, options }: StartDateSelectProps) => (
  <FormField
    control={control}
    name="newCustomerDate"
    render={({ field }) => (
      <FormItem>
        <Select value={field.value} onValueChange={field.onChange}>
          <FormControl>
            <SelectTrigger ref={field.ref} aria-label="Startdatum">
              <SelectValue placeholder="Bitte Startdatum auswählen" />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option} value={option}>
                Start am {formatDate(option)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <FormMessage />
      </FormItem>
    )}
  />
);

export default StartDateSelect;
